import { useTranslation } from "react-i18next";

function UploadImageComponent() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-5 h-52 w-full bg-mint-50 rounded border border-borderColor border-dashed">
      <img alt="" className="" src="/assets/images/UploadIcon.svg"></img>
      <div className="flex flex-col justify-center items-center gap-2">
        <div className="flex flex-row gap-2 font-ar text-base text-black">
          {t("uploadImage.component.dragAndDropOr")}
          <p className="text-mint-500">{t("uploadImage.component.browse")}</p>
        </div>
        <div dir="ltr" className="text-neutral-400 text-sm font-ar">
          2 MB /jpg , png
        </div>
      </div>
    </div>
  );
}

export default UploadImageComponent;
